import { Box, IconButton, Typography, Avatar } from '@mui/material'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { HeaderBox } from './MobileBookPage';
import { useTranslation } from 'react-i18next';
import BottomDesign from "../../Images/Image/botImg.png";
import Pravachans from '../../Services/Pravachans';
import gitasevalogo from "../../Images/logoGST.png";

// Reusable Card Component
const PravachanCard = ({ title, count, bgColor, img, titleColor, subTitleColor, ringColor, fallbackImg }: any) => {
  const [avatarSrc, setAvatarSrc] = React.useState(img || fallbackImg);

  React.useEffect(() => {
    setAvatarSrc(img || fallbackImg);
  }, [img, fallbackImg]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        backgroundColor: bgColor || "#f97316",
        borderTopLeftRadius: "1000px",
        borderBottomLeftRadius: "1000px",
        borderTopRightRadius: "750px",
        borderBottomRightRadius: "0px",
        p: 1.5,
        height: "70px",
        boxShadow: "0 3px 6px rgba(0,0,0,0.15)",
        cursor: "pointer",
        zIndex: 1000,
      }}
    >
      {avatarSrc && (
        <Avatar
          src={avatarSrc}
          imgProps={{
            onError: () => setAvatarSrc(fallbackImg),
          }}
          sx={{
            width: 45,
            height: 45,
            outline: `2px solid ${ringColor || "#FF8C00"}`,
            outlineOffset: "4px",
          }}
        />
      )}

      <Box>
        <Typography fontWeight="bold" style={{ fontSize: '14px', color: titleColor || '#000' }}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" style={{ color: subTitleColor || 'gray', fontSize: '12px', fontWeight: '600' }}>
          कुल रिकॉर्ड : {count}
        </Typography>
      </Box>
    </Box>
  );
}

const MobilePravachans = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [authors, setAuthors] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchAuthors = async () => {
      try {
        const res = await Pravachans.getPravachanAuthorCount('hi');
        if (res?.status && res?.result) {
          setAuthors(res.result);
        }
      } catch (err) {
        console.error("Error fetching authors", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAuthors();
  }, []);

  return (
    <Box sx={{
      backgroundColor: "#F2F0EF",
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      position: "relative",
    }}>
      {/* Header */}
      <HeaderBox>
        <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 16, top: 35, p: 0 }}>
          <ArrowBackIosIcon sx={{ color: "white", fontSize: '18px' }} />
        </IconButton>
        <IconButton onClick={() => navigate("/")} sx={{ position: 'absolute', left: 48, top: 35, p: 0 }}>
          <HomeOutlinedIcon sx={{ color: "white", fontSize: '24px' }} />
        </IconButton>
        <Typography variant="caption" sx={{ color: "#ffffffdd", opacity: 0.9, mb: 0.5 }}>
          {t("shrihari_tr")}
        </Typography>
        <Typography variant="h6" sx={{ color: "#ffffffdd", opacity: 0.9, fontSize: 15 }}>
          {t("Pravachan_tr")}
        </Typography>
      </HeaderBox>

      {/* Grid Section */}
      <Box
        sx={{
          flex: 1,
          display: "grid",
          gridTemplateColumns: "1fr",
          gap: 1.5,
          p: 2,
          overflowY: "auto",
          pb: "90px",
        }}
      >
        {loading ? (
          <Typography>Loading...</Typography>
        ) : (
          <>
            {authors
              .filter((a) => a.isSpecial)
              .map((author, index) => (
                <div onClick={() => {console.log(author,"authors");
                  
                   navigate("/pravachans",{state:{ type:"pravachans", isSpecial:author.isSpecial, authorName:author.name } } )
                  
                  }
               } key={author.id || index}>
                  <PravachanCard
                    key={author.id || index}
                    title={author.name}
                    count={author.recordCount}
                    bgColor="#FF8C00"
                    img={author.authorThumbPath}
                    fallbackImg={gitasevalogo}
                    titleColor="white"
                    subTitleColor="white"
                    ringColor="#FFE0B2"
                  />
                </div>
              ))}
            {authors
              .filter((a) => !a.isSpecial)
              .map((author, index) => (
                <div onClick={() =>{console.log("slugg",author?.orderNo);if(String(author.id).toLowerCase()==="other"){navigate("/pravachans",{state:{ type:"pravachans", isOther:true, authorName:author.name }})}else{navigate("/pravachans",{state:{ type:"pravachans", authorId:author.id, authorName:author.name }})}}} key={author.id || index}>
                  <PravachanCard
                    key={author.id || index}
                    title={author.name}
                    count={author.recordCount}
                    bgColor="#FFE0B2"
                    img={author.authorThumbPath}
                    fallbackImg={gitasevalogo}
                    titleColor="#000"
                    subTitleColor="gray"
                    ringColor="#FF8C00"
                  />
                </div>
              ))}
            <div onClick={() => navigate("/pravachans",{state:{ type:"pravachans" }})}>
              <PravachanCard
                title="सभी प्रवचन"
                count={authors.reduce((acc, curr) => acc + (curr.recordCount || 0), 0)} 
                bgColor="#FFE0B2"
                img={gitasevalogo}
                fallbackImg={gitasevalogo}
                titleColor="#000"
                subTitleColor="gray"
                ringColor="#FF8C00"
              />
            </div>
          </>
        )}

      </Box>

      {/* Bottom Image fixed */}
      <Box
        sx={{
          position: "fixed",
          left: 0,
          bottom: 0,
          width: "100%",
          zIndex: 10,
        }}
      >
        <img src={BottomDesign} alt="Bottom Design" style={{ width: '100%' }} />
      </Box>
    </Box>
  )
}

export default MobilePravachans;
